import FallbackLoader from '../FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-CercacasaLocalitySearch" */'@modals/partials/cerca-casa/LocalitySearch'));
